import React, { FC, useMemo, useRef } from 'react';

import DataGrid, {
  Column,
  ColumnChooser,
  Export,
  FilterPanel,
  FilterRow,
  GroupPanel,
  HeaderFilter,
  Pager,
  Paging,
  StateStoring,
} from 'devextreme-react/data-grid';

import { AppCard, AppLayoutTop } from 'components/appComponents';
import $createStore from 'utils/create-store-instance';
import { onExporting } from 'utils/exportingExcel';

const ChangeCashFlowIncomeSelling: FC = () => {
  const requestDateSource = useMemo(() => {
    return $createStore('/v1/Employee/roles', 'employeeId');
  }, []);

  const refGrid = useRef<DataGrid | null>(null);

  return (
    <div className="container-dev">
      <AppLayoutTop title="Сотрудники и их роли" />

      <AppCard>
        <DataGrid
          dataSource={requestDateSource as any}
          showBorders={false}
          loadPanel={{
            enabled: true,
            text: 'Загрузка',
          }}
          ref={refGrid}
          remoteOperations={true}
          allowColumnResizing
          columnResizingMode="nextColumn"
          columnMinWidth={50}
          allowColumnReordering
          onExporting={onExporting}
        >
          <Export enabled={true} />
          <StateStoring enabled={true} type="localStorage" storageKey="EmployeeRoles" />
          <FilterRow visible={true} />
          <FilterPanel visible={true} />
          <HeaderFilter visible />
          <GroupPanel visible={true} />
          <ColumnChooser enabled={true} />
          <Column dataField="employeeName" caption="ФИО сотрудника" />
          <Column dataField="role" caption="Роль" />
          <Paging defaultPageSize={15} />
          <Pager showPageSizeSelector={true} allowedPageSizes={[15, 30, 50, 100]} />
        </DataGrid>
      </AppCard>
    </div>
  );
};

export default ChangeCashFlowIncomeSelling;
